import Button from "../Button/Button";
import styles from "./InputFile.module.scss";

export interface FileItem {
  filePath: string;
  fileName: string;
  fileType: string;
  dataBlob: string;
}

export interface InputFileProps {
  addFiles?: (file: File[]) => void;
  setFile?: (file: FileItem) => void;
  label?: string;
    accept?: string;
    isError?: boolean;
}
export default function InputFile({
  setFile,
  label = "Choisir un fichier",
  addFiles,
  accept,
  isError,
}: InputFileProps) {
  const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
  
    const filelist = e.target.files || [];

    const FileFormated: File[] = [];

    for (let i = 0; i < filelist.length; i++) {
      const file = filelist[i];
      FileFormated.push(file);
    }

    if (addFiles) {
      addFiles(FileFormated);
    }
  };
  return (
    <Button variant={ isError ?"red" :"gray"}>
      <label className={styles["label"]}>{label}</label>
      <input
        className={styles["input"]}
        type="file"
        onChange={handleFileChange}
        accept={accept}
        
      />
    </Button>
  );
}
